module.exports = __webpack_public_path__ + "static/derek-sivers-bb766b22cadc06d314a797693908ef51.jpg";